// extracted by mini-css-extract-plugin
module.exports = {"input":"Spinner_input__3oSVs"};